<template>
  <div>
    <v-card flat class="mx-auto" tile v-if="student">
    <v-img :src="getImage()" :lazy-src="getImage()" height="300px" dark>
      <template v-slot:placeholder>
        <v-row class="fill-height ma-0" align="center" justify="center">
          <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
        </v-row>
      </template>
      <v-container fill-height class="pa-0" grid-list-lg>
        <v-layout column fill-height class="pa-5">
        <v-flex shrink>
          <v-layout row>
            <v-flex shrink>
              <v-btn out dark color="primary" fab small @click="close">
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex shrink>
             
              <v-btn dark color="primary" fab small @click="edit">
                <v-icon>edit</v-icon>
              </v-btn>
             
            </v-flex>
            <v-flex shrink>
              <v-btn dark color="primary" fab small @click="removeFromClass">
                <v-icon>delete</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex shrink>
          <v-chip color="primary" label class="text-capitalize text-h5">
            <div >{{ student.Student.fullName }}</div>
          </v-chip>
          <!-- <v-card-title class="white--text">
            <div class="text-h4 pl-5 text-capitalize">
              
            </div>
          </v-card-title> -->
        </v-flex>
      </v-layout>
      </v-container>
      

    </v-img>

    <v-list two-line>
      <v-list-item v-if="student.Student.Customer && student.Student.Customer.fatherPhoneNumber">
        <v-list-item-icon>
          <v-icon color="primary">
            mdi-phone
          </v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title><a style="text-decoration: none"
              :href="`tel:${student.Student.Customer.fatherPhoneNumber}`">{{
              student.Student.Customer.fatherPhoneNumber | USPhoneNumber
              }}</a></v-list-item-title>
          <v-list-item-subtitle>Father: <span class="text-capitalize font-weight-medium">{{
          student.Student.Customer.fatherName
          }}</span></v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-icon v-if="student.Student.Customer.fatherPhoneNumber">
          <a style="text-decoration: none" :href="`sms:${student.Student.Customer.fatherPhoneNumber}`">
            <v-icon color="primary">mdi-message-text</v-icon>
          </a>
        </v-list-item-icon>
      </v-list-item>

      <v-list-item v-if="student.Student.Customer && student.Student.Customer.motherPhoneNumber">
        <v-list-item-icon>
          <v-icon color="primary">
            mdi-phone
          </v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>
            <a style="text-decoration: none" :href="`tel:${student.Student.Customer.motherPhoneNumber}`">{{
            student.Student.Customer.motherPhoneNumber | USPhoneNumber
            }}</a>
          </v-list-item-title>
          <v-list-item-subtitle v-if="student.Student.Customer.motherName">Mother: <span
              class="text-capitalize font-weight-medium">{{ student.Student.Customer.motherName }}</span>
          </v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-icon>
          <a style="text-decoration: none" :href="`sms:${student.Student.Customer.motherPhoneNumber}`">
            <v-icon>mdi-message-text</v-icon>
          </a>
        </v-list-item-icon>
      </v-list-item>

      <v-divider inset v-if="student.Student.Customer && student.Student.Customer.fatherEmailAddress"></v-divider>

      <v-list-item v-if="student.Student.Customer && student.Student.Customer.fatherEmailAddress">
        <v-list-item-icon>
          <v-icon color="primary">
            mdi-email
          </v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>
            <a style="text-decoration: none" :href="`mailto:${student.Student.Customer.fatherEmailAddress}`">
              {{ student.Student.Customer.fatherEmailAddress }}
            </a>

          </v-list-item-title>
          <v-list-item-subtitle>Father: <span class="text-capitalize font-weight-medium">{{
          student.Student.Customer.fatherName
          }}</span></v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item v-if="student.Student.Customer && student.Student.Customer.motherEmailAddress">
        <v-list-item-action></v-list-item-action>

        <v-list-item-content>
          <v-list-item-title>
            <a style="text-decoration: none" :href="`mailto:${student.Student.Customer.fatherEmailAddress}`">
              {{ student.Student.Customer.fatherEmailAddress }}
            </a>
          </v-list-item-title>
          <v-list-item-subtitle>Mother:
            <span v-if="student.Student.Customer.motherName" class="text-capitalize font-weight-medium">{{
            student.Student.Customer.motherName
            }}</span>
            <span v-else class="text-capitalize font-weight-medium">N/A</span>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider inset v-if="student.Student.Customer && student.Student.Customer.address"></v-divider>

      <v-list-item @click="openGoogleMap" v-if="student.Student.Customer && student.Student.Customer.address">
        <v-list-item-icon>
          <v-icon color="primary">
            mdi-map-marker
          </v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ student.Student.Customer.address }}</v-list-item-title>
          <v-list-item-subtitle class="text-capitalize">{{ student.Student.Customer.city }}, <span
              class="text-uppercase">{{
              student.Student.Customer.state
              }}</span> {{ student.Student.Customer.zip }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider inset v-if="student.Student.Customer && student.Student.Customer.emergencyPhoneNumber"></v-divider>

      <v-list-item v-if="student.Student.Customer && student.Student.Customer.emergencyPhoneNumber">
        <v-list-item-icon>
          <v-icon color="primary">
            mdi-car-emergency
          </v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>
            <a style="text-decoration: none" :href="`tel:${student.Student.Customer.emergencyPhoneNumber}`">{{
            student.Student.Customer.emergencyPhoneNumber | USPhoneNumber
            }}</a>
          </v-list-item-title>
          <v-list-item-subtitle>Father: <span class="text-capitalize font-weight-medium">{{
          student.Student.Customer.emergencyName
          }}</span></v-list-item-subtitle>
          <v-list-item-subtitle>Relation: <span class="text-capitalize font-weight-medium">{{
          student.Student.Customer.emergencyRelation
          }}</span></v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-icon>
          <a style="text-decoration: none; color: gray"
            :href="`sms:${student.Student.Customer.emergencyPhoneNumber}`">
            <v-icon>mdi-message-text</v-icon>
          </a>
        </v-list-item-icon>



      </v-list-item>

      <v-divider inset></v-divider>

      <v-list-item>
        <v-list-item-icon>
          <v-icon color="primary">
            mdi-school
          </v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>Total Attendance Taken: {{ student.totalAttendance }}</v-list-item-title>
          <v-list-item-subtitle><span class="text-capitalize font-weight-medium">{{ student.totalPresentAttendance
          }}</span> | Present</v-list-item-subtitle>
          <v-list-item-subtitle><span class="text-capitalize font-weight-medium">{{ student.totalAbsentAttendance
          }}</span><span class="red--text"> | Absent</span></v-list-item-subtitle>
          <v-list-item-subtitle><span class="text-capitalize font-weight-medium">{{ student.totalLateAttendance
          }}</span> | Late</v-list-item-subtitle>
          <v-list-item-subtitle><span class="text-capitalize font-weight-medium">{{ student.totalLeaveAttendance
          }}</span> | Leave</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-progress-circular :size="35" :width="3" :value="student.per" color="teal">
            <span class="caption">{{ student.per }}</span>
          </v-progress-circular>
        </v-list-item-action>
      </v-list-item>


    </v-list>
  </v-card>
    <Edit @submit="close" @close="editDialog = !editDialog" :editStudent="student.Student" :editDialog="editDialog"/>
  </div>
</template>
<script>
import studentService from "@/modules/Student/service.js";
import classRoomService from "@/modules/ClassRoom/service.js";
import Edit from '@/modules/TeacherModules/Students/Edit.vue'

export default {
  name: 'teacher-student-profile',
  data() {
    return {
      editDialog: false,
      editMode: false,
      dialog: null,
      student: null,
      id: null,
      ClassRoomId: null,
    }
  },
  components: {
    Edit,
  },
  // watch: {
  //   openDialog(val) {
  //     this.dialog = val
  //     if (val) {
  //       this.student = JSON.parse(JSON.stringify(this.selectedStudent.Student))
  //     }
  //   }
  // },
  created() {
    console.log('his.$route', Object.keys(this.$route.params).length)
    console.log('his.$route', this.$route.params)
    if (Object.keys(this.$route.params).length === 0) {
      this.$router.push({ name: 'thome' })

    } else {
      this.student = this.$route.params.student
      this.selectedClassRoom = this.$route.params.selectedClassRoom
      console.log('student', this.student)
      console.log('selectedClassRoom', this.selectedClassRoom)
      // this.getStudent()
    }
    // this.getStudent()
    // this.getClassRoom()
  },
  methods: {
    edit() {
      this.editDialog = !this.editDialog
    },
    getStudent() {
      // console.log('thsi.studndf', this.student)
      // this.id = this.$route.params.id
      // this.ClassRoomId = this.$route.params.room
      studentService.getById(this.id, { includeCustomer: true })
        .then(response => {
          console.log('resop', response.data)
          this.student = response.data
          if (this.student) {
            document.title = `taleem - ${this.student.fullName}`;
          }

        })
    },
    getClassRoom() {
      classRoomService.getById(this.ClassRoomId)
        .then(response => {
          console.log('response', response)
        })
    },
    openGoogleMap() {
      const customer = this.selectedStudent.student.Student.Customer
      window.open(
        `https://www.google.com/maps/place/${customer.address} ${customer.city},${customer.state} ${customer.zip}`,
        "_blank"
      );
    },
    getImage() {
      const image = [
        'https://media.istockphoto.com/videos/islamic-interior-mosque-window-or-door-with-beam-of-ray-light-coming-video-id1139418471?s=640x640',
        'https://media.istockphoto.com/videos/islamic-interior-mosque-window-or-door-with-beam-of-ray-light-coming-video-id1138645349?s=640x640',
        'https://ak.picdn.net/shutterstock/videos/1026677408/thumb/10.jpg',
        'https://st2.depositphotos.com/1904083/6499/i/600/depositphotos_64992431-stock-photo-quran-holy-book-of-islam.jpg',
        'https://static9.depositphotos.com/1252160/1199/i/600/depositphotos_11994230-stock-photo-holy-quran-with-rays.jpg',
        'https://media.istockphoto.com/photos/hope-picture-id510158116?k=20&m=510158116&s=612x612&w=0&h=P3BUOYE7PR3KPp89Jnr82sEeulKEgOS2WU_sKi0YAYU=',
        'https://thumbs.dreamstime.com/b/al-quran-16105140.jpg',
        'https://media.springernature.com/lw685/springer-static/image/art%3A10.1186%2Fs40410-022-00155-4/MediaObjects/40410_2022_155_Fig3_HTML.jpg',
        'https://cdn.shopify.com/s/files/1/1046/9544/products/image_bf020a6f-a0e2-450a-8790-d3f579c27a75_large.jpg?v=1611376994',
        'https://media.istockphoto.com/photos/stone-grating-at-humayuns-tomb-in-new-delhi-india-picture-id655471632?b=1&k=20&m=655471632&s=170667a&w=0&h=D-nPQ3biePPZiTsATWWOXPGtZb4d-wUG43iXYEv-nvg=',
        'https://i.pinimg.com/736x/e3/8f/51/e38f5119897d3a4f81ed85bb860acc85.jpg',
        'https://png.pngtree.com/thumb_back/fh260/background/20210503/pngtree-eid-mubarak-elegant-red-islamic-background-image_709297.jpg',
        'https://png.pngtree.com/thumb_back/fh260/background/20210501/pngtree-eid-mubarak-background-with-red-gradient-mosque-image_699434.jpg',
        'https://static.vecteezy.com/system/resources/previews/002/934/896/non_2x/islamic-background-with-mosque-design-free-vector.jpg',
        'https://images.unsplash.com/photo-1542816417-0983c9c9ad53?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8aXNsYW1pYyUyMGJhY2tncm91bmR8ZW58MHx8MHx8&w=1000&q=80',
        'https://w0.peakpx.com/wallpaper/394/121/HD-wallpaper-quraan-beautiful-blak-dark-islamic-muslims-quran-red.jpg',
        'https://i.pinimg.com/736x/71/04/33/710433a51149f780a43f1e60bb4858be.jpg',
        'https://i.pinimg.com/originals/24/0b/bf/240bbfbe83271541247c3a7b39ed538c.jpg',
        'https://media.istockphoto.com/videos/ramadan-islamic-background-video-id1145001136?s=640x640',
        'https://tasbihdigital.com/islam-wallpaper-hd-653/islam-wallpaper-hd/',
        'https://media.istockphoto.com/videos/copy-space-eid-al-adha-ramadan-mubarak-islamic-background-decorations-video-id1307383438?s=640x640',
        'https://st3.depositphotos.com/4719539/15220/v/600/depositphotos_152201698-stock-illustration-islamic-background-design.jpg',
        'https://wallpaperaccess.com/full/44567.jpg',
        'https://cdn.wallpapersafari.com/0/44/wa90Et.jpg',
        'https://cdn.wallpapersafari.com/25/14/YsvHdO.jpg',
        'https://i.pinimg.com/564x/25/df/77/25df77a09cadd4512e1f44f075b8420c.jpg',
        'https://media.istockphoto.com/photos/dome-of-an-old-mosque-with-a-crescent-picture-id1291549435?b=1&k=20&m=1291549435&s=170667a&w=0&h=8uHiU042PEIDnkRvrY286QvcXSunN4qHjAakpPCK7yA=',
        'https://cdn.pixabay.com/photo/2016/11/12/20/26/mosque-1819673__340.jpg',
        'https://wallpapercave.com/wp/wp6316693.jpg',
        'https://indwallpapers.com/wp-content/uploads/2022/02/Islamic-Android-Wallpaper.jpg',

      ]
      const number = Math.floor(Math.random() * image.length)
      return image[number]
    },
    removeFromClass() {
      console.log('selectedStudent', this.selectedStudent)
      this.$swal({
        title: "Are you sure?",
        text: `You want to remove ${this.student.Student.fullName} from this Class`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          classRoomService.removeStudent(this.student.id).then((response) => {
            if (response.data) {
              // this.$swal("Remove!", "Teacher has been Remove.", "success");
              this.$router.push({ name: 'thome' })
            }
          });
        }
      });
    },
    close() {
      // this.$emit('close')
      this.$router.push({ name: 'thome' })
    }
  }
}
</script>

<style scoped>

</style>